import React, { useState } from 'react';
import './AddTextModal.css';
import { FaTimes, FaPlus } from 'react-icons/fa';

const AddTextModal = ({ isOpen, onClose, onSubmit }) => {
  const [content, setContent] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (content.trim()) {
      onSubmit({ content: content.trim() });
      setContent('');
    }
  };

  const handleClose = () => {
    setContent('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Додади текст</h3>
          <button className="close-button" onClick={handleClose}>
            <FaTimes />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="text-content">Текст:</label>
            <textarea
              id="text-content"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="Внесете го текстот тука..."
              rows={4}
              required
              autoFocus
            />
          </div>
          
          <div className="modal-actions">
            <button type="button" onClick={handleClose} className="cancel-button">
              Откажи
            </button>
            <button type="submit" className="submit-button" disabled={!content.trim()}>
              <FaPlus /> Додади
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTextModal;